import { modulo } from 'libs';

export function modularDistance(a, b, m){
	const delta =  modulo(b, m) -  modulo(a, m);
	const abs 	= Math.abs(delta);
	if(abs < m/2)
		return delta;
	return -(m - abs) * Math.sign(delta);
}